/**
 * Shared helpers for the bonus engine UI (Phase 2).
 *
 * Keeps the small bits (progress %, currency-chip labels, remaining-wager
 * math, active-claim detection) in one place so Promotions, Wallet, and
 * the AppShell badge stay consistent.
 */
import { CURRENCIES, formatAmount } from "./currency";

export const BONUS_TYPE_LABEL = {
  deposit_match: "Deposit match",
  cashback: "Cashback",
  game_free_credit: "Free credit",
};

export const BONUS_TYPE_TONE = {
  deposit_match: "hot",
  cashback: "gold",
  game_free_credit: "new",
};

export const CLAIM_STATUS_LABEL = {
  pending: "Pending",
  active: "In progress",
  completed: "Completed",
  forfeited: "Forfeited",
  expired: "Expired",
};

export const CLAIM_STATUS_TONE = {
  pending: "muted",
  active: "hot",
  completed: "success",
  forfeited: "danger",
  expired: "muted",
};

export function isActiveStatus(status) {
  return status === "pending" || status === "active";
}

export function progressPct(claim) {
  const req = Number(claim?.wagering_required || 0);
  if (req <= 0) return 100;
  const done = Number(claim?.wagering_completed || 0);
  return Math.min(100, Math.round((done / req) * 100 * 10) / 10);
}

export function remainingWager(claim) {
  const req = Number(claim?.wagering_required || 0);
  const done = Number(claim?.wagering_completed || 0);
  return Math.max(0, req - done);
}

/** Human-readable summary for a bonus card's currency line. */
export function currencyChipLabels(currencies) {
  if (!currencies || currencies.length === 0) return CURRENCIES.map((c) => c.code);
  return currencies.map((c) => String(c).toUpperCase());
}

/** Format the "Wagering ৳150 / ৳6000" line used across the wallet page. */
export function formatWagerLine(claim) {
  const done = Number(claim?.wagering_completed || 0);
  const req = Number(claim?.wagering_required || 0);
  return `${formatAmount(done, claim.currency)} / ${formatAmount(req, claim.currency)}`;
}
